// export const BASE_URL = "http://localhost/generalservices";

export const BASE_URL = "https://safprotech.com/generalservices";


